/**
 * Created by pekkap on 28.9.2015.
 * Leaderboard component for gimlet player
 * @component {"type":"Leaderboard","version":"1.0"}
 */

define('leaderboard',['jquery', 'knockout'], function($, ko) {
    'use strict';

    return function(parentVM, dataContext) {

        var self		    	= this,
            tvm                 = parentVM.training,
            leaderboardComponent,
            numberOfResults;

        self.leaderboardTitle   = ko.observable();
        self.leaderboardItems   = ko.observableArray();
        self.currentUserScore   = ko.observable();

        self.pageChanged = function(){

            if (tvm.getComponentsByKind) {
                leaderboardComponent = tvm.getComponentsByKind('Leaderboard')[0];
            }

            if(leaderboardComponent){
                numberOfResults = parseInt(leaderboardComponent.content.numberOfResults);
                getCurrentUserScore();
                self.leaderboardTitle(leaderboardComponent.content.titleLabel);
                getLeaderboardData(numberOfResults);
            }

        };

        // called once at the end of trainingVM
        function init() {
            // pageChanged won't otherwise be called on the 1st page
            self.pageChanged();
        }

        // Fetch user ranking
        function getCurrentUserScore() {
            tvm.getCurrentUserScore(function(data){
                self.currentUserScore(data);
            });
        }

        // Fetch top 10 learners
        function getLeaderboardData(amount) {
            tvm.getTopScoreLearners(amount, refreshLeaderBoard);
        }

        // refresh leaderboard items
        function refreshLeaderBoard(data) {
            self.leaderboardItems([]);
            var userInTopScore = false;

            $.each(data, function( index, value ) {

                var valueObj = value;
                if (valueObj.userId === tvm.dataContext.userID) {
                    valueObj.classes = "current-user";
                    userInTopScore = true;
                }
                self.leaderboardItems.push(valueObj);
            });

            // user score not in top score list then add it
            if (!userInTopScore) {
                var valueObj = self.currentUserScore();
                if (valueObj) {
                    valueObj.classes = "current-user";

                    if (self.leaderboardItems().length === numberOfResults) {
                        self.leaderboardItems.pop(); // remove last from the list and replace with user results
                        self.leaderboardItems.push(valueObj);
                    }

                }
            }
        }

        init($, dataContext.learning);

    }
});

